import React from 'react';
import { StepperFooterProps } from './dynamicStepperFormInterface';
import { CommonButton } from 'sharedComponents/index';
import { useTranslation } from 'react-i18next';

const StepperFooter: React.FC<StepperFooterProps> = ({ currentStep, stepConfig, handleBack, handleNext }) => {
  const { t } = useTranslation();

  const footerNote = stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.message;
  const footerComponent = stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.footerComponent;
  const backNavigation =
    stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.footerNavigationProps?.backNavigation;

  const submitButtonVisibility =
    stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.footerNavigationProps
      ?.submitButtonVisibility ?? true;

  const buttonTitle =
    stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.footerNavigationProps?.buttonTitle ||
    (currentStep < stepConfig.length - 1 ? t('stepperForm.continue') : t('stepperForm.submit'));

  const fullWidthBtn =
    stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.footerNavigationProps?.fullWidth || false;

  const nextNavigation =
    stepConfig?.[currentStep]?.[Object.keys(stepConfig[currentStep])[0]]?.footerNavigationProps?.nextNavigation;

  return (
    <div className='dy-stepper-form__footer'>
      <div className='dy-stepper-form__footer__actions'>
        {currentStep > 0 && backNavigation !== false && (
          <CommonButton
            type={'button'}
            onClick={handleBack}
            label={t('stepperForm.back')}
            variant='outlined'
            minWidth='180px'
            className='back'
          />
        )}
        {nextNavigation !== false && currentStep < stepConfig.length - 1 && (
          <CommonButton
            type={'button'}
            onClick={handleNext}
            label={buttonTitle}
            minWidth='180px'
            fullWidth={fullWidthBtn}
            // disabled={true}
          />
        )}
        {currentStep === stepConfig.length - 1 && submitButtonVisibility && (
          <CommonButton type={'submit'} label={buttonTitle} minWidth='180px' fullWidth={fullWidthBtn} />
        )}
      </div>

      {footerNote && (
        <div className='note text-center'>
          <small>{footerNote}</small>
        </div>
      )}
      {footerComponent && <div className='note text-center'>{footerComponent}</div>}
    </div>
  );
};

export default StepperFooter;
